export const convertBoolApiToFormValue = (value: boolean | null | undefined): boolean | undefined => {
  if (typeof value === 'boolean') {
    return value;
  }
  return undefined;
};
